export default __webpack_public_path__ + "images/HELLOFLY.ef17415.png";